import Vue from '../externals/vue'; // Hack to work-around bundling issue
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
  observer: true,
  lazyComponent: true,
});
